/*
 * Валидация ИНН (Индивидуальный номер налогоплательщика)
 * Поддерживает ИНН физических лиц (12 цифр) и юридических лиц (10 цифр)
 */
export function validateInn(inn?: string): inn is string {
    return (inn?.length === 10 || inn?.length === 12) && /^\d+$/.test(inn);
}
